import TimeClock from "./TimeClock";
import { Box , useMediaQuery,} from "@mui/material";
import map from "../../../../assets/Attendance/map.png";
import CustomButton from "../../../../components/CustomButton";
import { showUnderDevelopment } from "../../../../components/alerts";
import { useTranslation } from "react-i18next";
import maparrow from "../../../../assets/maparrow.svg";
import AttendanceTable from "./AttendanceTable";
import MapSection from "./MapSection";
import {useState} from "react";
import { useLocation,useNavigate } from "react-router-dom";
import back from "../../../../assets/back.svg";
import CustomText, { textStyles } from "../../../../components/CustomText";
const TodayPunch = () => {
      const { t } = useTranslation();
        const isMobile = useMediaQuery("(max-width:768px)");
          const [records, setRecords] = useState([]);
            const [refreshKey, setRefreshKey] = useState(0); //
            const location = useLocation();
  const navigate = useNavigate();
  const fromDashboard = location.state?.fromDashboard;
  const [selectedPunch, setSelectedPunch] = useState(null);

  return (
    <Box sx={{  p: 1,}}>

                       {fromDashboard && (
        <Box
          sx={{
            border: '1px solid #E4E6EF',
            borderRadius: 2,
            px: 2,
            backgroundColor: 'white',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            minHeight: 55,
            mb: 2,
            ml:1, mr:1,
         
          }}
        >
          <Box
            sx={{ display: 'flex', alignItems: 'center', gap: 1.5, cursor: 'pointer' }}
            onClick={() => navigate(-1)}
          >
            <img src={back} style={{ width: 30, height: 30 }} />
            <CustomText
              sx={{
                ...textStyles.h1,
                fontWeight: 500,
                fontSize: '14px',
                color: '#626F86',
                textAlign: 'center'
              }}
            >
              {t('worker')} 
            </CustomText>
          </Box>
        </Box>
      )}


<Box
  sx={{
    display: "grid",
    gap: 2,
    gridTemplateColumns: {
      xs: "1fr",
      md: "400px 1fr",   // fixed width for TimeClock
    },
  }}
>
  <Box sx={{ maxWidth: "400px", width: "100%" }}>
    <TimeClock onPunchSuccess={() => setRefreshKey(k => k + 1)} />
  </Box>
      <MapSection  records={records}
  selectedPunch={selectedPunch}
  onClearSelection={() => setSelectedPunch(null)} />
    
    </Box>
    <Box sx={{mt:2}}>
        <AttendanceTable   key={refreshKey}
  onRecordsChange={setRecords}
  onRowSelect={setSelectedPunch} />
    </Box>
    </Box>
  );
};

export default TodayPunch;
